import { signInWithEmailAndPassword, signOut, type Auth } from "firebase/auth";
import type { LoginCredentials } from "../types";

export const login = async (auth: Auth, credentials: LoginCredentials) =>
  await signInWithEmailAndPassword(
    auth,
    credentials.email,
    credentials.password,
  );

export const logout = async (auth: Auth): Promise<void> => await signOut(auth);
